/**
 * Heading. IMPORTANT: Chakra applies a `textStyle` prop as *defaults*, so it can never override the font-size that
 * Heading's own `size` sets. On <Heading> use `size`, which mirrors the textStyle ramp exactly:
 *   size="2xl" = display.lg · "xl" = display.md · "lg" = h1 · "md" = h2 (default) · "sm" = h3 · "xs" = h4
 * If you need a textStyle on a heading element instead, use <Text as="h2" textStyle="h2">.
 */
export const Heading = {
  baseStyle: { fontFamily: "heading", fontWeight: 700, color: "text.primary", lineHeight: 1.2 },
  sizes: {
    "2xl": {
      fontSize: "2.75rem",
      lineHeight: 1,
      letterSpacing: "-0.025em",
      fontVariantNumeric: "tabular-nums lining-nums",
      fontVariationSettings: '"opsz" 72',
    },
    xl: { fontSize: "2rem", lineHeight: 1.1, letterSpacing: "-0.02em", fontVariationSettings: '"opsz" 48' },
    lg: { fontSize: "1.5rem", lineHeight: 1.2, letterSpacing: "-0.015em" },
    md: { fontSize: "1.375rem", lineHeight: 1.2, letterSpacing: "-0.01em" },
    sm: { fontSize: "1.125rem", lineHeight: 1.3, letterSpacing: "-0.005em" },
    xs: { fontSize: "1rem", lineHeight: 1.35, letterSpacing: "0" },
  },
  defaultProps: { size: "md" },
};
